import { router } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

import { FollowUpsCard } from '@/components/dashboards/follow-ups-card';
import { TodaySection } from '@/components/dashboards/today-section';
import { ExpandableFAB, HeadingText } from '@/components/ui';
import { WorkOrdersList } from '@/components/work-orders/work-orders-list';
import { useApi } from '@/hooks/use-api';
import { useApprovalQueue } from '@/hooks/use-approval-queue';
import { useLocation } from '@/hooks/use-location';
import { usePermissions } from '@/hooks/use-permissions';
import { buttonStyles } from '@/styles/components/buttons';

/** The small-screen Work Orders page (`/work-orders`); Home is `V2Dashboard` (#279). */
const MobileDashboard: React.FC = () => {
	const { location } = useLocation();
	const { user } = useApi();
	const { isMaintenance, canCreateWorkOrders, canViewApprovalQueue } = usePermissions();
	// Scope for the approvals list — the same hook the banner reads, so they agree.
	const approvalQueue = useApprovalQueue();

	return (
		<View style={{
			flex: 1,
			padding: 0,
			margin: 0,
			width: '100%',
		}}>
			<WorkOrdersList
				maxItems={200}
				assignedTo={isMaintenance ? user?.id : undefined}
				maxDueDays={30}
				currentLocation={location}
				useFlatList
				headerComponent={
					<View>
						{/*
							Approvals first (#496). Self-hides when the queue is empty.
						*/}
						{canViewApprovalQueue && (
							/* `params` is spread, not cherry-picked — see the note in dashboards/default.tsx. */
							<WorkOrdersList
								headerComponent={<HeadingText style={{ marginBottom: 16 }}>
									Work Orders Needing Approval
								</HeadingText>}
								{...approvalQueue.params}
								sortBy="completed_at"
								sortOrder="asc"
								maxItems={50}
								currentLocation={location}
								style={{ marginBottom: 16 }}
								hideIfEmpty
							/>
						)}
						{/* Follow-ups pinned at the top of the dashboard (#48). */}
						<FollowUpsCard style={{ marginBottom: 16 }} />
						<TodaySection style={{ marginBottom: 16 }} />
					</View>
				}
			/>
			{canCreateWorkOrders && (
				<ExpandableFAB
					onWorkOrderPress={() => router.push('/work-orders/new', {
						withAnchor: true,
					})}
					onRecurringWorkOrderPress={() => router.push('/work-orders/new?recurring=1', {
						withAnchor: true,
					})}
					onQuotePress={() => router.push('/quotes/new', {
						withAnchor: true,
					})}
					style={buttonStyles.fab}
				/>
			)}
		</View>
	);
};

export default MobileDashboard;
